import { ApplicationRef, ComponentRef, createComponent, effect, EnvironmentInjector, inject, Injectable, Injector, signal } from '@angular/core';
import { OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class EventsListenerService {

  private appRef: ApplicationRef;
  private injector!: EnvironmentInjector;
  private modalRef: ComponentRef<ModalComponent> | null = null;

  private readonly authService: AuthService = inject(AuthService);

  constructor() {
    effect(() => {
      console.log('Event from service: ', this.authService.oauthEvents());
    })
  }

  setInjector(injector: EnvironmentInjector) {
    this.injector = injector;
  }

  displayModalSessionExpired() {
    if(this.modalRef) return;


    const titleNode = document.createElement('div');
    titleNode.setAttribute('title', '');
    titleNode.textContent = 'Sesion por expirar';


    const contentNode = document.createElement('div');
    titleNode.setAttribute('content', '');
    titleNode.innerHTML = 'La session esta por expirar';

    this.modalRef = createComponent(ModalComponent, {
      environmentInjector: this.injector,
      projectableNodes: [[titleNode], [contentNode]]
    });

    
    this.appRef.attachView(this.modalRef.hostView);
    const domElem = (this.modalRef.hostView as any).rootNode[0] as HTMLElement;
    document.body.appendChild(domElem);
    
    
    this.modalRef.instance.onClose.subscribe((res) => console.log('You close modal!', res));

  }

  destoyModal() {
    if(this.modalRef) {
      this.appRef.detachView(this.modalRef.hostView);
      this.modalRef?.destroy();
      this.modalRef = null;
    }
  }
}
